export default "__VITE_ASSET__a10d517b__"